module.exports = __webpack_public_path__ + "static/media/Artboard21.0bc75f22.png";